// extracted by mini-css-extract-plugin
module.exports = {"view":"Form_view__mY_lJ","infoBlock":"Form_infoBlock__3hLst"};